import {
  type CanvasElementFrom,
  type WithIoConfig,
  type WithProps,
} from '@blaze-runtime/engine-domain';

import { registerElementDefinition } from '../../services/element-definitions.service';

import { getBarChartDefinition } from './bar-chart.element';
import { type ChartPropsModel, type ChartValuePropsModel } from './chart.models';
import { getColumnChartDefinition } from './column-chart.element';
import { getDotChartDefinition } from './dot-chart.element';
import { getDoughnutChartDefinition } from './doughnut-chart.element';
import { getLineChartDefinition } from './line-chart.element';
import { getPieChartDefinition } from './pie-chart.element';
import { getChartSingleDefinition } from './value-chart.element';

export type ChartElement = CanvasElementFrom<
  | 'chartSingle'
  | 'chartLine'
  | 'chartBar'
  | 'chartColumn'
  | 'chartPie'
  | 'chartDoughnut'
  | 'chartDot'
>;
export type ChartDef = WithProps<ChartPropsModel> & WithIoConfig;
export type SingleChartDef = WithProps<ChartValuePropsModel> & WithIoConfig;

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    chartColumn: ChartDef;
    chartBar: ChartDef;
    chartLine: ChartDef;
    chartPie: ChartDef;
    chartSingle: SingleChartDef;
    chartDoughnut: ChartDef;
    chartDot: ChartDef;
  }
}

registerElementDefinition(getBarChartDefinition());
registerElementDefinition(getColumnChartDefinition());
registerElementDefinition(getLineChartDefinition());
registerElementDefinition(getPieChartDefinition());
registerElementDefinition(getDoughnutChartDefinition());
registerElementDefinition(getChartSingleDefinition());
registerElementDefinition(getDotChartDefinition());
